var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:[{'mt-3':!_vm.noMarginTop}],style:(_vm.style),attrs:{"align":"center"}},[_c('v-spacer'),(_vm.line)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size,"width":_vm.width}}):_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size,"width":_vm.width}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }